import React, { useState } from "react";
import BoardsSpecsTable from "./BoardsSpecsTable";
import Img from "gatsby-image";
import { getFields } from "../utils/functions";
import ComparisonSearchModal from "./ComparisonSearchModal";

const DynamicComparisonTable = ({
  boardsData,
  category,
  onAddBoard,
  onRemoveBoard,
}) => {
  const tableHead = boardsData => (
    <thead>
      <tr>
        <th className="border-r border-white"></th>
        {(boardsData || []).map((board, i) => (
          <th key={i} className="p-2 border-r border-white">
            <div className="flex flex-col justify-center">
              <div className="flex justify-end mb-2">
                <button
                  onClick={() => onRemoveBoard(board.id)}
                  className="flex items-center justify-center bg-gray-300 text-gray-500 h-4 w-4 text-xs rounded-full md:h-6 md:w-6 md:text-base focus:outline-none focus:shadow-outline"
                >
                  <i className="fa fa-times" />
                </button>
              </div>
              <div>
                <Img
                  alt={board.title}
                  fluid={board.featured_image.img.childImageSharp.fluid}
                  className="max-h-40"
                />
              </div>
            </div>
          </th>
        ))}
        {boardsData &&
          boardsData.length < 4 &&
          emptyColumns(4 - boardsData.length)}
      </tr>
    </thead>
  );

  const emptyColumns = num => {
    const arr = new Array(num);
    arr.fill(0, 0, num);
    return arr.map((_, i) => (
      <th key={i}>
        <div className="flex justify-center"></div>
      </th>
    ));
  };

  // console.log("current added boards", boardsData);
  return (
    <BoardsSpecsTable
      boardsData={boardsData}
      fields={getFields(category)}
      tableHead={tableHead}
      comparePage
    />
  );
};

export default DynamicComparisonTable;
